<template>
  <q-table
    hide-bottom
    title="Credentials"
    :columns="tableColumns"
    :data="credentials || []"
    :loading="!credentials || loading"
  >
    <template #body="props">
      <q-tr :props="props">
        <q-td key="name" :props="props">
          {{ props.row.label }}
        </q-td>

        <q-td key="userName" :props="props">
          <q-input v-model="props.row.username" dense outlined></q-input>
        </q-td>

        <QInputShowHide v-model="props.row.password" td-key="password" :props="props" />

        <QInputShowHide v-model="props.row.api_key" td-key="apiKey" :props="props" />

        <q-td key="status" :props="props">
          {{ statusColumn(props.row.validated_at) }}
        </q-td>

        <q-td key="actions" :props="props">
          <q-btn
            size="sm"
            color="tertiary"
            label="Save and validate"
            :disable="isRowUpdated(props.row)"
            @click="saveAndFinalize(props.row)"
          ></q-btn>
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script>
import * as apiTo from '../api'

//Libraries
import moment from 'moment'
import { cloneDeep } from 'lodash'

// Components
import QInputShowHide from '@/reusable/base-components/QInputShowHide'

export default {
  components: {
    QInputShowHide
  },

  data: () => ({
    tableColumns: [
      { name: 'name', label: 'Name', align: 'left' },
      { name: 'userName', label: 'Username', align: 'left' },
      { name: 'password', label: 'Password', align: 'left' },
      { name: 'apiKey', label: 'Api key', align: 'left' },
      { name: 'status', label: 'Status', align: 'left', style: 'width: 300px' },
      { name: 'actions', label: 'Actions', align: 'left' }
    ],
    loading: false,
    credentials: null,
    originalCredentials: null
  }),

  created() {
    this.getCredentials()
  },

  methods: {
    getCredentials() {
      apiTo.getCredentials().then(({ data }) => {
        const credentials = cloneDeep(data.result)
        this.originalCredentials = data.result
        this.credentials = credentials
      })
    },

    isRowUpdated({ id, username, password, api_key: apiKey }) {
      const originalData = this.originalCredentials.find(e => e.id === id)
      return (
        (username || null) === originalData.username &&
        (password || null) === originalData.password &&
        (apiKey || null) === originalData.api_key
      )
    },

    statusColumn(date) {
      if (!date) return 'Invalid'
      const localDate = moment
        .tz(date, this.settings.timezone)
        .local()
        .format('YYYY-MM-DD H:mm:ss')
      return `Valid (${localDate})`
    },

    saveAndFinalize({ id, data_source, username, password, api_key }) {
      this.loading = true
      apiTo
        .updateCredential(id, { data_source, username, password, api_key })
        .then(({ data: { result } }) => {
          const index = this.credentials.findIndex(e => e.id === result.id)
          this.credentials.splice(index, 1, cloneDeep(result))
          this.originalCredentials.splice(index, 1, result)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
